import React, { useState } from "react";
import PaymentSummery from "./PaymentSummery";
import AppointmentSuccess from "./AppointmentSuccess";

const PaymentMobileComponent = ({
    handleBookAppointment,
    setShowForm,
    isAppointmentSuccessful,
}) => {
    const [payState, setPayState] = useState(false);
    const isMobile = window.innerWidth <= 768;

    return (
        <div className="w-100">
            {isAppointmentSuccessful ? (
                <AppointmentSuccess />
            ) : (
                <div className="col-lg-6 px-2">
                    <div className="f600-18px text-center d-flex w-100 align-items-cecnter justify-content-between">
                        <div
                            className={`w-100 ${
                                payState ? "unselected-tab" : "selected-tab"
                            }`}
                            onClick={() => setPayState(!payState)}
                        >
                            Pay Now
                        </div>
                        <div
                            className={`w-100 ${
                                payState ? "selected-tab" : "unselected-tab"
                            }`}
                            onClick={() => setPayState(!payState)}
                        >
                            Pay Later
                        </div>
                    </div>
                    {payState ? (
                        <div>
                            <ul className="left-bar">
                                <li className="f500-16px">
                                    All charges, registration fees etc, shall be
                                    levied as per standard Hospital Policy and
                                    shall be payable at the hospital billing
                                    desk
                                </li>
                                <li className="f500-16px">
                                    With Pay Now Facility, you have a
                                    hassle-free Option to make your payment
                                    Online
                                </li>
                            </ul>
                            <div>
                                <PaymentSummery />
                                <div className="d-flex justify-content-center gap-2">
                                    <div
                                        className="w-100 back-button"
                                        onClick={() => setShowForm("")}
                                    >
                                        Back
                                    </div>
                                    <div
                                        className="w-100 payment-btn"
                                        onClick={() => {
                                            // setIsAppointmentSuccessful(true);
                                            handleBookAppointment();
                                        }}
                                    >
                                        Pay Later
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <ul className="right-bar">
                                <li className="f500-16px">
                                    With Pay Now Facility, you have a
                                    hassle-free Option to make your payment
                                    Online
                                </li>
                                <li className="f500-16px">
                                    All charges, registration fees etc, shall be
                                    levied as per standard Hospital Policy and
                                    shall be payable at the hospital billing
                                    desk
                                </li>
                            </ul>
                            <div>
                                <PaymentSummery />
                                <div className="d-flex justify-content-center gap-2">
                                    <div
                                        className="w-100 back-button"
                                        onClick={() => setShowForm("")}
                                    >
                                        Back
                                    </div>
                                    <div
                                        className="w-100 payment-btn"
                                        onClick={() => {
                                            // setIsAppointmentSuccessful(true);
                                            handleBookAppointment();
                                        }}
                                    >
                                        Pay Now
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            <div className="payment-footer">
                        <div className={isMobile ? "f500-16px mb-2" : "f-title mb-2"}>Note :</div>
                        <ul className={isMobile ? "f500-14px" : "f-text"}>
                            <li>
                                Please login to patient portal on for
                                Cancellation/ Reprint Receipt/ Diagnostic
                                Reports/ Appointment and other details
                            </li>
                            <li>
                                Please use your “UHID” as UserID and “Registered
                                Mobile No.” as password.
                            </li>
                            <li>
                                We request you to reach Hospital 30 min before
                                your scheduled appointment time for completing
                                your Vital Checks at Nursing station and any
                                other formalities, as may be required.
                            </li>
                        </ul>
                    </div>
        </div>
    );
};

export default PaymentMobileComponent;
